import { AuditRecord } from './auditRecord';

/**
 * The audit export (spec section 5.8): one JSON object per line, so the record can be attached to
 * the ship package and read by the out-of-process CLI verifier.
 *
 * The export is an ADDITION to the durable log, never the log itself (BAR-SFR-02). Nothing here
 * removes or rewrites a record.
 */

export const BASIL_AUDIT_MIME = 'application/x-ndjson';

/** Records as JSONL, oldest first, with a trailing newline. */
export function toJsonl(records: readonly AuditRecord[]): string {
  if (records.length === 0) {
    return '';
  }

  return `${records.map((record) => JSON.stringify(record)).join('\n')}\n`;
}

/** A file name that carries the episode and the moment, and no story text. */
export function auditFileName(storyId: number, at?: Date): string {
  const stamp = (at || new Date()).toISOString().replace(/[:.]/g, '-');

  return `basil-audit-${storyId}-${stamp}.jsonl`;
}

/**
 * The export as a Blob, ready for an object URL.
 *
 * `Blob` is used directly rather than through a helper so the caller can revoke its own object URL
 * on the same tick it created it.
 */
export function toJsonlBlob(records: readonly AuditRecord[]): Blob {
  return new Blob([toJsonl(records)], { type: BASIL_AUDIT_MIME });
}
